import React, { memo, useLayoutEffect, useRef } from 'react';
import { Group } from 'three';
import { useDataStore } from '../../zustand';
import { useGetSceneContent } from './trackerGroupHooks';

interface IPlacementSceneProps {
	sceneId: string;
}

const PlacementScene: React.FunctionComponent<IPlacementSceneProps> = ({ sceneId }) => {
	const groupRef = useRef<Group>(null);
	const componentsById = useDataStore((state) => state.componentsById);
	const sceneContent = useGetSceneContent(sceneId, componentsById, false)

	useLayoutEffect(() => {
		groupRef.current?.traverse((node: any) => {
			if (node.isMesh) {
				node.material.transparent = true;
				node.material.opacity = node.material.opacity * 0.7;
			}
		});
	}, [sceneId]);

	return (
		<group ref={groupRef} name="placement_scene">
			{sceneContent}
		</group>
	);
};

PlacementScene.displayName = 'PlacementScene';
export default memo(PlacementScene);
